/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Clips_BulldogInputs */

const en_road_dude_clips_bulldog = /** @type {(inputs: Road_Dude_Clips_BulldogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The bulldog in the white pickup`)
};

const zh_road_dude_clips_bulldog = /** @type {(inputs: Road_Dude_Clips_BulldogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`白色皮卡里的斗牛犬`)
};

/**
* | output |
* | --- |
* | "The bulldog in the white pickup" |
*
* @param {Road_Dude_Clips_BulldogInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_clips_bulldog = /** @type {((inputs?: Road_Dude_Clips_BulldogInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Clips_BulldogInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_clips_bulldog(inputs)
	return zh_road_dude_clips_bulldog(inputs)
});
export { road_dude_clips_bulldog as "road_dude.clips.bulldog" }